import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AlterarSenha.css";

const AlterarSenha = () => {
  const [formData, setFormData] = useState({
    senha_atual: "",
    nova_senha: "",
    confirmar_senha: "",
  });

  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMensagem("");
    setErro("");
    setLoading(true);

    if (formData.nova_senha !== formData.confirmar_senha) {
      setErro("A nova senha e a confirmação devem ser iguais.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch("https://welaunchyou.com.br/crm-wly/alterar_senha.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erro desconhecido.");
      }

      setMensagem("Senha alterada com sucesso!");
      setFormData({ senha_atual: "", nova_senha: "", confirmar_senha: "" });
    } catch (error) {
      setErro("Erro: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="alterar-container">
      <div className="alterar-form">
        <div className="alterar-header">
       <h2 style={{ borderBottom: "none" }}>Alterar Senha</h2>
        </div>
        {mensagem && <p className="sucesso">{mensagem}</p>}
        {erro && <p className="erro">{erro}</p>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="password"
              id="senha_atual"
              name="senha_atual"
              placeholder="Senha Atual"
              value={formData.senha_atual}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              id="nova_senha"
              name="nova_senha"
              placeholder="Nova Senha"
              value={formData.nova_senha}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              id="confirmar_senha"
              name="confirmar_senha"
              placeholder="Confirmar Nova Senha"
              value={formData.confirmar_senha}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Alterando..." : "Alterar Senha"}
          </button>
        </form>

        <p className="forgot-password">
          <span onClick={() => navigate("/configuracoes")}>Voltar</span>
        </p>
      </div>
    </div>
  );
};

export default AlterarSenha;
